import { isAction, Middleware } from '@reduxjs/toolkit'
import { requestReferencesActions } from '@repo/core'

export const requestMiddleware: Middleware = (store) => (next) => (action) => {
  if (isAction(action) && 'payload' in action) {
    if (action.type.toLowerCase().includes('getrequest')) {
      store.dispatch(
        requestReferencesActions.addRequestReference({
          type: action.type,
          payload: JSON.stringify(action.payload),
          lastCall: new Date().toISOString(),
        }),
      )
    }
  }

  return next(action)
}
